import JourneyTablev2 from "./JourneyTablev2";

export default JourneyTablev2;
